module.exports = __webpack_public_path__ + "img/fenxiband.a9375c62.png";